export const getDefaultDatasetsNameMapper = (datasets) => datasets
    .reduce((acc, dataset) => (Object.assign(Object.assign({}, acc), { [dataset.id]: dataset.name })), {});
